import React, {useEffect, useState} from "react";
import {MapContainer, TileLayer, GeoJSON, useMap} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import Loader from "../shared/Loader";

const FranceMap = ({highlightedPostCodes}) => {
  const [geoData, setGeoData] = useState(null);
  const [center, setCenter] = useState(null);
  const [zoom, setZoom] = useState(11);
  const [twoLengthPostCodes, setTwoLenghtPostCodes] = useState([]);
  // Load the GeoJSON file with postal code boundaries
  useEffect(() => {
    let isMounted = true;
    fetch("/data/contours-codes-postaux.geojson") // Replace with your GeoJSON path
      .then((response) => response.json())
      .then((data) => {
        if (isMounted) setGeoData(data);
      });
    return () => {
      isMounted = false; // Mark component as unmounted
    };
  }, []);

  // Update center based on highlighted postal codes
  useEffect(() => {
    if (geoData && highlightedPostCodes?.length) {
      const feature = geoData.features.find(
        (feature) =>
          highlightedPostCodes.includes(
            feature.properties.codePostal.slice(0, 2),
          ) || highlightedPostCodes.includes(feature.properties.codePostal),
      );
      setTwoLenghtPostCodes(
        highlightedPostCodes.filter((post) => post.length === 2),
      );

      if (feature) {
        const coordinates = feature.geometry.coordinates[0][0];

        setCenter([coordinates[1], coordinates[0]]);
      } else {
        setCenter([48.66, 2.756]);
      }
    }
    if (!!highlightedPostCodes && !highlightedPostCodes.length) {
      setCenter([47.06, 2.756]);
      setZoom(6);
    }
  }, [geoData, highlightedPostCodes]);

  // Style function for GeoJSON layers
  const style = (feature) => ({
    fillColor:
      highlightedPostCodes.includes(feature.properties.codePostal) ||
      twoLengthPostCodes.filter((ele) =>
        feature.properties.codePostal.startsWith(ele),
      ).length
        ? "#FF6600"
        : "#CCCCCC",
    weight:
      highlightedPostCodes.includes(feature.properties.codePostal) ||
      twoLengthPostCodes.filter((ele) =>
        feature.properties.codePostal.startsWith(ele),
      ).length
        ? 1
        : 0,
    color:
      highlightedPostCodes.includes(feature.properties.codePostal) ||
      twoLengthPostCodes.filter((ele) =>
        feature.properties.codePostal.startsWith(ele),
      ).length
        ? "#FF6600"
        : "transparent",
    fillOpacity:
      highlightedPostCodes.includes(feature.properties.codePostal) ||
      twoLengthPostCodes.filter((ele) =>
        feature.properties.codePostal.startsWith(ele),
      ).length
        ? 0.7
        : 0,
  });
  if (!center || !geoData || !Array.isArray(center) || center.length !== 2) {
    return <Loader className={"!relative  !top-12"} />;
  }

  return (
    <MapContainer
      className="rounded-2xl aspect-[3/2] md:aspect-square w-full "
      center={center}
      zoom={zoom}
      // style={{width: "100%", aspectRatio: 1 / 1}}
    >
      {!!center && !!geoData && <MapInvalidateSize center={center} />}
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {geoData && <GeoJSON data={geoData} style={style} />}
    </MapContainer>
  );
};
const MapInvalidateSize = ({center}) => {
  const map = useMap();

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      setTimeout(() => {
        map.invalidateSize();
      }, 2000);
    }

    return () => {
      isMounted = false; // Prevent map operations after unmount
    };
  }, [map, center]);

  return null;
};

export default FranceMap;
